// Tarquínio Beach Club — full menu data
// "featured: true" marks "Mais pedidos" (3–5 dishes per Tarquinio's house favourites)

export const TARQ_MENU = [
  {
    id: "peixe-marisco",
    label: "Peixe & Marisco",
    intro: "Da costa ao prato. Tradição atlântica.",
    items: [
      { name: "Sardinhas Assadas", price: "14,90" },
      { name: "Robalo Grelhado", price: "17,90" },
      { name: "Salmão Grelhado", price: "17,90" },
      { name: "Feijoada de Choco com Gambas", note: "para 2 pessoas", price: "27,90" },
      { name: "Bacalhau à Lagareiro com Batata a Murro", price: "19,90", featured: true },
      { name: "Polvo à Lagareiro", price: "19,90", featured: true },
      { name: "Caril de Gambas com Arroz", price: "19,90" },
      { name: "Espetada de Lulas e Gambas", price: "19,90" },
      { name: "Choco Frito com Batata e Salada", price: "16,90" },
      { name: "Jaquinzinhos Fritos com Arroz de Tomate", price: "14,90" },
      { name: "Dose de Legumes", price: "4,90" },
    ],
  },
  {
    id: "carne",
    label: "Carne",
    intro: "Clássicos portugueses e um toque do Brasil.",
    items: [
      { name: "Picanha Fatiada à Moda do Brasil", price: "19,90", featured: true },
      { name: "Arroz de Pato à Portuguesa", price: "14,90" },
      { name: "Bitoque", price: "14,90" },
      { name: "Omelete de Queijo e Fiambre", note: "com batata e salada", price: "13,90" },
      { name: "Omelete Simples", note: "com batata e salada", price: "11,90" },
    ],
  },
  {
    id: "saladas",
    label: "Saladas",
    intro: "Leveza e frescura à beira-mar.",
    items: [
      { name: "Salada Mista", price: "9,90" },
      { name: "Salada de Atum", price: "15,90" },
      { name: "Salada de Frango", price: "15,90" },
      { name: "Salada da Praia", price: "16,90" },
      { name: "Salada do Mar", price: "17,90", featured: true },
    ],
  },
  {
    id: "sopas",
    label: "Sopas",
    intro: "Para começar devagar.",
    items: [
      { name: "Sopa de Legumes", price: "3,90" },
      { name: "Canja de Amêijoas", price: "6,90" },
      { name: "Creme de Marisco", price: "6,90" },
    ],
  },
  {
    id: "entradas-petiscos",
    label: "Entradas & Petiscos",
    intro: "Para dividir, conversar e demorar.",
    items: [
      { name: "Pão", price: "0,80" },
      { name: "Manteiga", note: "unidade", price: "0,50" },
      { name: "Queijo Seco", price: "3,90" },
      { name: "Queijo de Cabra em Azeite", price: "8,90" },
      { name: "Caracóis", price: "8,90" },
      { name: "Choco Frito", price: "9,90" },
      { name: "Pica-Pau de Vaca", price: "9,90" },
      { name: "Pica-Pau de Porco", price: "8,90" },
      { name: "Pimentos Padrón", price: "9,90" },
      { name: "Chouriço Assado", price: "9,90" },
      { name: "Moelas", price: "8,90" },
      { name: "Gambas à Guilho", price: "10,90" },
      { name: "Camarão Panado", price: "9,90" },
      { name: "Mexilhão de Tomatada", price: "13,90" },
      { name: "Calamares", price: "8,90" },
      { name: "Salada de Polvo", price: "10,90" },
      { name: "Casco de Sapateira Recheado", price: "11,90" },
      { name: "Amêijoa à Bulhão Pato", price: "18,90", featured: true },
      { name: "Ovos Rotos", price: "9,90" },
      { name: "Batata Frita", note: "dose", price: "2,90" },
    ],
  },
  {
    id: "sandes-tostas",
    label: "Sandes & Tostas",
    intro: "Clássicos do bar, bem feitos.",
    items: [
      { name: "Prego", price: "6,90" },
      { name: "Bifana", price: "5,90" },
      { name: "Cachorro", price: "4,90" },
      { name: "Sandes de Atum", price: "3,90" },
      { name: "Sandes de Frango", price: "3,90" },
      { name: "Sandes de Fiambre", price: "2,50" },
      { name: "Sandes de Queijo", price: "2,50" },
      { name: "Sandes Mista", price: "3,90" },
      { name: "Sandes de Salmão Fumado", price: "5,90" },
      { name: "Pão com Manteiga", price: "1,90" },
      { name: "Torrada", price: "2,90" },
      { name: "Tosta Mista", price: "6,90" },
      { name: "Tosta de Atum", price: "6,90" },
      { name: "Tosta de Frango", price: "6,90" },
      { name: "Tosta de Salmão Fumado", price: "7,90" },
      { name: "Tosta de Abacate com Tomate", price: "6,90" },
    ],
  },
  {
    id: "hamburgueres",
    label: "Hambúrgueres",
    intro: "Na pão artesanal, com acompanhamento.",
    items: [
      { name: "Hambúrguer com Queijo", price: "6,90" },
      { name: "Hambúrguer com Queijo, Cebola e Bacon", price: "8,90" },
      { name: "Hambúrguer com Queijo, Alface e Ovo", price: "8,90" },
      { name: "Hambúrguer Vegetariano com Espinafres", price: "5,90" },
    ],
  },
  {
    id: "menus-praia",
    label: "Menus Praia",
    intro: "Completo: prato + bebida. Pensado para o verão.",
    items: [
      {
        name: "Menu Praia 1",
        desc: "Pastéis de Bacalhau no prato, arroz e salada + bebida",
        price: "12,90",
        featured: true,
      },
      {
        name: "Menu Praia 2",
        desc: "Hambúrguer no prato com ovo, batata e salada + bebida",
        price: "12,90",
      },
      {
        name: "Menu Praia 3",
        desc: "Febras de porco, batata e salada + bebida",
        price: "12,90",
      },
      {
        name: "Menu Praia 4",
        desc: "Hambúrguer de espinafres, batata e salada + bebida",
        price: "12,90",
      },
      {
        name: "Menu Vegetariano",
        desc: "Gyozas vegetarianas com legumes salteados + bebida",
        price: "13,90",
      },
      {
        name: "Menu Infantil",
        desc: "Peito de frango grelhado, batata frita e arroz + sumo de laranja",
        price: "9,90",
      },
    ],
  },
  {
    id: "sobremesas",
    label: "Sobremesas",
    intro: "Um final doce, ao sabor do oceano.",
    items: [
      { name: "Crepe de Chocolate com Gelado", price: "4,90" },
      { name: "Bolo de Chocolate Quente com Gelado", price: "4,90" },
      { name: "Pudim Flan", price: "4,90" },
      { name: "Taça de Gelado", note: "2 bolas", price: "4,90" },
      { name: "Mousse de Chocolate", price: "4,90" },
    ],
  },
  {
    id: "extras",
    label: "Extras",
    intro: "Pequenos prazeres.",
    items: [{ name: "Açaí", note: "copo", price: "6,90" }],
  },
];
